"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormDecimalField = void 0;
const decimal_field_1 = require("../../../components/decimal-field/decimal-field");
const form_field_1 = require("./form-field");
exports.FormDecimalField = (0, form_field_1.formFieldFactory)(decimal_field_1.DecimalField);
//# sourceMappingURL=form-decimal-field.js.map